import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export enum ResearchOptionsStatus {
  PENDING = 'pending',
  READY = 'ready',
  FAILED = 'failed',
}

export interface ResearchDecisionOptionsPayload {
  phase_id: number
  student_id: number
  options: string[]
  status: ResearchOptionsStatus
  error_message?: string | null
}

export interface ResearchModeState {
  optionsByKey: Record<string, ResearchDecisionOptionsPayload>
}

export function researchOptionsKey(phaseId: number, studentId: number) {
  return `${phaseId}:${studentId}`
}

const initialState: ResearchModeState = {
  optionsByKey: {},
}

const researchModeSlice = createSlice({
  name: 'researchMode',
  initialState,
  reducers: {
    setResearchDecisionOptions: (
      state,
      action: PayloadAction<ResearchDecisionOptionsPayload>
    ) => {
      const k = researchOptionsKey(
        action.payload.phase_id,
        action.payload.student_id
      )
      state.optionsByKey[k] = action.payload
    },
    clearResearchDecisionOptions: (
      state,
      action: PayloadAction<{ phaseId: number; studentId: number }>
    ) => {
      delete state.optionsByKey[
        researchOptionsKey(action.payload.phaseId, action.payload.studentId)
      ]
    },
  },
})

export const { setResearchDecisionOptions, clearResearchDecisionOptions } =
  researchModeSlice.actions

export default researchModeSlice.reducer
